import axiosInstance from '../../utils/axiosConfig';

// Action Types
export const GET_ALL_SERVICES = "GET_ALL_SERVICES";
export const CREATE_SERVICE = "CREATE_SERVICE";
export const UPDATE_SERVICE = "UPDATE_SERVICE";
export const DELETE_SERVICE = "DELETE_SERVICE";
export const SERVICES_FAILURE = "SERVICES_FAILURE";

// API Endpoints
const BASE_URL = process.env.REACT_APP_BACKEND_URL_MS_CLAIMMANAGEMENT;
const GET_ALL_SERVICES_URL = `${BASE_URL}/service/getAll`;
const CREATE_SERVICE_URL = `${BASE_URL}/service/create`;
const UPDATE_SERVICE_URL = (serviceId) => `${BASE_URL}/service/update/${serviceId}`;
const DELETE_SERVICE_URL = (serviceId) => `${BASE_URL}/service/delete/${serviceId}`;

// Action Creators
export const getAllServices = () => async (dispatch) => {
  try {
    const response = await axiosInstance.get(GET_ALL_SERVICES_URL);
    dispatch({
      type: GET_ALL_SERVICES,
      payload: response.data,
    });
    return response.data; // Return for additional processing if needed
  } catch (error) {
    console.error("Error fetching services:", error);
    dispatch({
      type: SERVICES_FAILURE,
      payload: error.response ? error.response.data : "Server error",
    });
  }
};

export const createService = (serviceData) => async (dispatch) => {
  try {
    const response = await axiosInstance.post(CREATE_SERVICE_URL, serviceData);
    dispatch({
      type: CREATE_SERVICE,
      payload: response.data,
    });
    return response.data; // Return for additional processing if needed
  } catch (error) {
    console.error("Error creating service:", error);
    dispatch({
      type: SERVICES_FAILURE,
      payload: error.response ? error.response.data : "Server error",
    });
  }
};

export const updateService = (serviceId, updatedData) => async (dispatch) => {
  try {
    const response = await axiosInstance.put(UPDATE_SERVICE_URL(serviceId), updatedData);
    dispatch({
      type: UPDATE_SERVICE,
      payload: response.data,
    });
    return response.data; // Return for additional processing if needed
  } catch (error) {
    console.error("Error updating service:", error);
    dispatch({
      type: SERVICES_FAILURE,
      payload: error.response ? error.response.data : "Server error",
    });
  }
};

export const deleteService = (serviceId) => async (dispatch) => {
  try {
    await axiosInstance.delete(DELETE_SERVICE_URL(serviceId));
    dispatch({
      type: DELETE_SERVICE,
      payload: serviceId, // Return the deleted service ID for state updates
    });
  } catch (error) {
    console.error("Error deleting service:", error);
    dispatch({
      type: SERVICES_FAILURE,
      payload: error.response ? error.response.data : "Server error",
    });
  }
};
